<template>
  <div class="shoucang_mobile">
    <div class="shoucang-top">
      <div>
        <img
          src="../../public/statics/img/mobile/icon_return.png"
          alt=""
          @click="backto"
        />
      </div>
      <div class="carAndshoucang">
        <div :class="isactive == 1 ? 'active' : ''" @click="changeAct(1)">
          购物车({{ dataList.length }})
        </div>
        <div :class="isactive == 2 ? 'active' : ''" @click="changeAct(2)">
          我的收藏({{ dataList1.length }})
        </div>
      </div>

      <div class="edits" v-show="edit == 1" @click="changeedit(2)">
        <span> 编辑</span>
      </div>
      <div class="edits" v-show="edit == 2" @click="changeedit(1)">
        <span>完成</span>
      </div>
    </div>
    <div
      class="shoucang-content"
      v-if="isactive == 1 && this.dataList.length >= 1"
    >
      <div class="content" v-for="(item, index) in dataList" :key="index">
        <div class="content-left">
          <el-checkbox
            v-model="item.checked"
            @change.native="cout()"
          ></el-checkbox>
        </div>
        <div class="content-right">
          <div class="right-left">
            <!-- <img :src="item.image" alt="" /> -->
            <img :src="item.image" alt="" v-if="item.image != ''" />
            <img src="../../public/statics/img/shop/none.png" alt="" v-else />
          </div>
          <div class="right-right">
            <div>{{ item.goods_name }}</div>
            <div class="price">￥{{ item.price }}</div>
            <div class="pNum">
              <!-- <div v-if="item.goods_spec != ''" class="div">
                订货编号：{{ item.goods_spec }}
              </div> -->
              <!-- <div v-else class="div">订货编号：--</div> -->

              <div>
                <el-input-number
                  v-model="item.cart_num"
                  @change="handleChange(item.id, item.cart_num)"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="shoucang-content"
      v-if="isactive == 2 && this.dataList1.length >= 1"
    >
      <div class="content" v-for="(item, index) in dataList1" :key="index">
        <div class="content-left">
          <el-checkbox
            v-model="item.checked"
            @change.native="cout1()"
          ></el-checkbox>
        </div>
        <div class="content-right">
          <div class="right-left">
            <img :src="item.image" alt="" v-if="item.image != ''" />
            <img src="../../public/statics/img/shop/none.png" alt="" v-else />
          </div>
          <div class="right-right">
            <div>{{ item.goods_name }}</div>
            <div class="price">￥{{ item.price }}</div>
            <div class="pNum">
              <!-- <div class="div">订货编号：{{ item.pNum }}</div> -->
              <!-- <div>
                <el-input-number
                  v-model="item.num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                ></el-input-number>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="shoucang-content"
      v-if="isactive == 1 && this.dataList.length == 0"
    >
      <div class="content-l">
        <img src="../../public/statics/img/shop/Nullcar.png" alt="" />
        <div class="nullThing">
          <div class="thingTip">购物车还没有产品~</div>
          <div class="thingGO" @click="thingGo">
            <button>去购物</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="shoucang-content"
      v-if="isactive == 2 && this.dataList1.length == 0"
    >
      <div class="content-l">
        <img src="../../public/statics/img/shop/Nullcang.png" alt="" />
        <div class="nullThing">
          <div class="thingTip">暂时还没有收藏产品~</div>
        </div>
      </div>
    </div>
    <div
      class="shoucang-bottom"
      v-show="edit == 1 && this.dataList.length >= 1"
    >
      <div class="bottom-left">
        <el-checkbox v-model="checkall" @change.native="allcheck"></el-checkbox>
        全选
      </div>
      <div class="bottom-content">
        总计:<span>￥{{ allprice }}</span>
      </div>
      <div class="bottom-right" @click="buys">申请购买({{ nums }})</div>
    </div>

    <div
      class="shoucang-bottom"
      v-show="edit == 1 && isactive == 2 && this.dataList1.length >= 1"
    >
      <div class="bottom-left">
        <el-checkbox
          v-model="checkall1"
          @change.native="allcheck1"
        ></el-checkbox>
        全选
      </div>
      <!-- <div class="bottom-content">
        总计:<span>￥{{ allprice }}</span>
      </div> -->
      <div class="bottom-right" @click="addcar">加入购物车</div>
    </div>
    <div
      class="shoucang-bottom"
      v-show="edit == 2 && isactive == 1 && this.dataList.length >= 1"
    >
      <div class="bottom-left">
        <el-checkbox v-model="checkall" @change.native="allcheck"></el-checkbox>
        全选
      </div>
      <!-- <div class="bottom-content">总计:<span>￥316.00</span></div> -->
      <div class="bottom-right1" @click="deleteData">删除</div>
    </div>
    <div
      class="shoucang-bottom"
      v-show="edit == 2 && isactive == 2 && this.dataList1.length >= 1"
    >
      <div class="bottom-left">
        <el-checkbox
          v-model="checkall1"
          @change.native="allcheck1"
        ></el-checkbox>
        全选
      </div>
      <!-- <div class="bottom-content">总计:<span>￥316.00</span></div> -->
      <div class="bottom-right1" @click="deleteData1">删除</div>
    </div>
    <div style="width: 100%; height: 0.6rem"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import "../../public/statics/css/base.css";
import { auth, anth } from "../request/api";
export default {
  name: "shoucang_mobile",
  data() {
    return {
      isactive: 1,
      edit: 1,
      nums: 0,
      checkall: false,
      checkall1: false,
      dataList: [],
      dataList1: [],
      allprice: 0,
      allprice1: 0,
    };
  },
  watch: {},
  components: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
    document.body.scrollTop = -85;
    document.documentElement.scrollTop = -85;
    this.isactive = this.$route.query.types;
    this.getCar();
    this.getCang();
  },
  methods: {
    changeAct(e) {
      this.isactive = e;
      this.edit = 1;
      this.nums = 0;
      this.allprice = 0;
      this.checkall = false;
      this.checkall1 = false;
      this.allcheck();
      this.allcheck1();

      if (e == 1) {
        this.getCar();
      } else if (e == 2) {
        this.getCang();
      }
    },
    thingGo() {
      this.$router.push({
        path: "/shop_mobile",
      });
    },
    getCar() {
      let url = "/v1/shop/my/cart";
      let data = {
        // page: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          console.log(res);
          res.data.data.list.forEach((e) => {
            e.checked = false;
          });
          this.dataList = res.data.data.list;
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },

    getCang() {
      let url = "/v1/shop/my/collect";
      let data = {
        // page: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          console.log(res);
          res.data.data.list.forEach((e) => {
            e.checked = false;
          });
          this.dataList1 = res.data.data.list;
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    // Buys() {
    //   let arr = [];
    //   let arr1 = {};
    //   this.dataList.forEach((e) => {
    //     if (e.checked == true) {
    //       arr.push(e.id);
    //     }
    //   });
    //   arr1 = arr.join(",");
    //   let url = "/v1/shop/my/pay";
    //   let data = {
    //     id: arr1,
    //   };
    //   auth(url, data).then((res) => {
    //     if (res.data.code == 1) {
    //       this.$message({
    //         type: "success",
    //         message: "提交成功",
    //       });
    //     } else {
    //       this.$message({
    //         type: "error",
    //         message: res.data.msg,
    //       });
    //     }
    //   });
    // },
    backto() {
      this.$router.push({
        path: "/shop_mobile",
      });
    },
    changeedit(e) {
      console.log(e);
      this.edit = e;
      this.nums = 0;
      this.allprice = 0;
      this.checkall = false;
      this.checkall1 = false;
      this.allcheck();
      this.allcheck1();
      if (e == 1) {
        this.getCar();
      } else if (e == 2) {
        this.getCang();
      }
    },
    buys() {
      let arr = [];
      let arr1 = {};
      this.dataList.forEach((e) => {
        if (e.checked == true) {
          arr.push(e.id);
        }
      });

      if (arr.length > 0) {
        arr1 = arr.join(",");
        let url = "/v1/shop/my/pay";
        let data = {
          id: arr1,
        };
        auth(url, data).then((res) => {
          if (res.data.code == 1) {
            Toast({
              message: "购买申请提交成功",
              position: "center",
            });
            this.getCar();
            setTimeout(() => {
              this.cout();
            }, 200);
            // this.getCang();
          } else {
            Toast({
              message: res.data.msg,
              position: "center",
            });
          }
        });
      } else {
        Toast({
          message: "请选择要购买的商品",
          position: "center",
        });
      }
    },
    allcheck() {
      if (this.checkall == true) {
        this.dataList.forEach((e) => {
          e.checked = true;
        });
        this.cout();
      }

      if (this.checkall == false) {
        this.dataList.forEach((e) => {
          e.checked = false;
        });
        this.cout();
      }
    },
    addcar() {
      let arr = [];
      this.dataList1.forEach((e) => {
        if (e.checked == true) {
          arr.push(e.goods_id);
        }
      });
      if (arr.length > 0) {
        let arr1 = arr.join(",");
        let url = "/v1/shop/my/addCart";
        let data = {
          id: arr1,
          num: 1,
        };
        auth(url, data).then((res) => {
          if (res.data.code == 1) {
            Toast({
              message: "添加成功",
              position: "center",
            });
          } else {
            Toast({
              message: res.data.msg,
              position: "center",
            });
          }
        });
      } else {
        Toast({
          message: "请选择要加入购物车的商品",
          position: "center",
        });
      }
    },
    allcheck1() {
      console.log(this.checkall, this.dataList1);
      if (this.checkall1 == true) {
        this.dataList1.forEach((e) => {
          e.checked = true;
        });

        // this.cout1();
      }

      if (this.checkall1 == false) {
        this.dataList1.forEach((e) => {
          e.checked = false;
        });
        // this.$forceUpdate()
        // this.cout1();
      }
      this.$forceUpdate();
    },
    deleteData() {
      let arr = [];
      let arr1 = {};
      // // let arr1=[];
      this.dataList.forEach((e, index) => {
        if (e.checked == true) {
          arr.push(e.id);
          //  this.deleteOne(e.id)
        }
      });
      if (arr.length > 0) {
        arr1 = arr.join(",");
        this.deleteOne(arr1);
      } else {
        Toast({
          message: "请选择要删除的商品",
          position: "center",
        });
      }
    },
    deleteData1() {
      let arr = [];
      let arr1 = {};
      // // let arr1=[];
      this.dataList1.forEach((e, index) => {
        if (e.checked == true) {
          arr.push(e.goods_id);
          //  this.deleteOne(e.id)
        }
      });
      if (arr.length > 0) {
        arr1 = arr.join(",");
        this.deleteOne1(arr1); // 2. 添加事件
      } else {
        Toast({
          message: "请选择要删除的商品",
          position: "center",
        });
      }
    },
    deleteOne(e) {
      let url = "/v1/shop/my/delCart";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "删除成功",
            position: "center",
          });
          this.getCar();
          this.getCang();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    deleteOne1(e) {
      let url = "/v1/shop/my/delCollect";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "取消成功",
            position: "center",
          });
          this.getCang();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    handleChange(e, i) {
      this.allprice = 0;
      this.nums = 0;
      this.cout();
      let url = "/v1/shop/my/cart_num";
      let data = {
        id: e,
        num: i,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    cout() {
      let arr = [];
      this.allprice = 0;
      this.nums = 0;
      // let price = 0;
      this.dataList.forEach((e) => {
        if (e.checked == true) {
          arr.push(e);

          let price = Number(e.price) * Number(e.cart_num);
          console.log(price);
          this.allprice += price;
          let nums = Number(e.cart_num);
          this.nums += nums;
          console.log(this.allprice);
          return this.price;
          // return this.nums;
        }
      });
      if (arr.length == this.dataList.length) {
        this.checkall = true;
      } else {
        this.checkall = false;
      }
    },
    cout1() {
      let arr = [];
      this.dataList1.forEach((e) => {
        if (e.checked == true) {
          arr.push(e);
        }
      });
      console.log(arr, this.dataList1);
      if (arr.length == this.dataList1.length) {
        this.checkall1 = true;
      } else {
        this.checkall1 = false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.shoucang_mobile {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  // background-color: rgba(244, 244, 244, 1);
  background-color: #f5f7fb;
  /deep/ .el-checkbox__inner {
    border-radius: 50%;
  }
  .shoucang-top {
    padding: 0 5%;
    background-color: #fff;
    display: flex;
    height: 3rem;
    justify-content: space-between;
    align-items: center;
    z-index: 555;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    border-bottom: 1px solid rgba(112, 112, 112, 0.1);
    box-sizing: border-box;
    img {
      width: 1.4rem;
      height: 1.4rem;
    }
    .carAndshoucang {
      width: 70%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 1rem;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 3rem;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
      div {
        width: 8rem;
      }
      .active {
        color: #f53d3d;
        border-bottom: 2px solid #f53d3d;
      }
    }
    .edits {
      width: 10%;
      height: 2rem;
      font-size: 0.8rem;
      font-family: PingFangSC-Regular, sans-serif;
      // line-height: 3rem;
      color: #333333;
      opacity: 1;
      display: flex;
      align-items: flex-end;
      span {
        display: block;
      }
    }
  }
  .shoucang-content {
    background-color: #fff;
    margin-top: 3rem;
    height: calc(100vh - 6rem);
    overflow-y: scroll;
    margin-bottom: 3rem;
    box-sizing: content-box;
    .content-l {
      // margin-top: 3rem;
      height: 100%;
      background-color: rgba(245, 247, 251, 1);
      .nullThing {
        font-family: "PingFang SC";
        font-weight: bold;
        .thingGO {
          margin-top: 1rem;
          button {
            width: 8.5rem;
            background-color: rgba(255, 154, 38, 1);
            color: #fff;
            text-align: center;
            line-height: 2.3rem;
            border: none;
            font-size: 1.1rem;
            border-radius: 0.33rem;
          }
        }
      }
    }
    .content {
      border-top: 1px solid rgba(112, 112, 112, 0.1);
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 1rem 0.5rem;
      .content-left {
      }
      .content-right {
        display: flex;
        justify-content: start;
        align-items: center;
        .right-left {
          width: 5rem;
          height: 6rem;
          padding: 0.2rem 0.6rem;

          box-sizing: border-box;
          // padding: 10%;
          // box-sizing: border-box;
          img {
            // margin: 0.2rem;
            width: 4.2rem;
            height: 5rem;
            // overflow: hidden;
          }
        }
        .right-right {
          font-size: 1rem;
          font-family: "PingFang SC";
          font-weight: bold;
          line-height: 1.3rem;
          text-align: left;
          color: #333333;
          opacity: 1;
          .price {
            font-size: 1.4rem;
            font-family: "PingFang SC";

            line-height: 2.5rem;
            color: #ff9a26;
            opacity: 1;
          }
          .pNum {
            // width: 87px;
            // height: 14px;
            width: 16rem;
            font-size: 0.7rem;
            font-family: PingFang SC;
            // font-weight: 400;
            line-height: 2rem;
            color: #999999;
            opacity: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .div {
              width: 50%;
            }
          }
        }
        /deep/ .el-input-number {
          width: 8rem;
          line-height: 2rem;
        }

        /deep/ .el-input-number__decrease {
          height: calc(2rem - 2px);
          line-height: calc(2rem - 2px);
          box-sizing: content-box;
          border-radius: 2px;
        }
        /deep/ .el-input-number__increase {
          height: calc(2rem - 2px);
          line-height: calc(2rem - 2px);
          box-sizing: content-box;
          border-radius: 2px;
        }
        /deep/ .el-input__inner {
          height: 2rem;
          line-height: 2rem;
          // border: none;
          border-radius: 0;
        }
      }
    }
  }
  .shoucang-bottom {
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 555;
    .bottom-left {
      // height: ;
      padding: 0 0.4rem;
      box-sizing: border-box;
    }
    .bottom-content {
      span {
        color: rgba(255, 154, 38, 1);
      }
    }
    .bottom-right {
      height: 3rem;
      width: 6rem;
      line-height: 3rem;
      text-align: center;
      background-color: rgba(255, 154, 38, 1);
      color: #fff;
    }
    .bottom-right1 {
      height: 3rem;
      width: 6rem;
      line-height: 3rem;
      text-align: center;
      background-color: rgba(245, 61, 61, 1);
      color: #fff;
    }
  }
}
</style>